import React, { useState } from "react";
import lavaImage from "./../../china-europe/china-europe-main/img/lava-img.svg";
import LogoImage from "./../../china-europe/china-europe-main/img/logo.svg";
import ChinaImage from "./../../china-europe/china-europe-main/img/image-china.jpg";
import UkraineImage from "./../../china-europe/china-europe-main/img/image-ukraine.jpg";

import { useNavigate } from "react-router-dom";

import "./../../../i18n";
import { useTranslation } from "react-i18next";

import "./style/select-content.css";
import LangSelect from "../../LangSelect/LangSelect";
import Footer from "../../china-europe/Footer/Footer";

function Item({ title, titleMain, img, onClick = () => {}, variant }) {
  const { t } = useTranslation();

  return (
    <div className="sc-item">
      <img src={img} className="sc-item-img" alt="Country" />
      <div className="sc-item-content">
        <h2 className={`sc-item-title sc-item-title--${variant}`}>
          {titleMain}
        </h2>
        <h2 className="sc-item-title">{title}</h2>
      </div>
      {/* <button
        className={`sc-item-btn sc-item-btn--${variant}`}
        onClick={() => {
          window.scrollTo(0, 0);
          onClick();
        }}
      >
        {t("SelectContent.btnText")}
      </button> */}
    </div>
  );
}

export default function SelectContent() {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="sc-wrapper">
      <img src={lavaImage} className="sc-lava-img" alt="Lava flowing" />

      <LangSelect
        className="sc-lang-selector"
        setIsOpen={setIsOpen}
        isOpen={isOpen}
      />

      <div className="sc-container">
        <img src={LogoImage} className="sc-logo" alt="Logo" />

        <h1 className="sc-title">{t("SelectContent.title")}</h1>

        <div className="sc-desc-container">
          <p className="sc-desc">{t("SelectContent.desc1")}</p>
          <p className="sc-desc">{t("SelectContent.desc2")}</p>
          <p className="sc-desc">{t("SelectContent.desc3")}</p>
        </div>

        <p className="sc-desc sc-desc--bold">{t("SelectContent.desc4")}</p>

        <div className="sc-items">
          <Item
            title={t("SelectContent.cardTitle1")}
            titleMain={t("SelectContent.cardTitle1Main")}
            img={UkraineImage}
            variant="blue"
            onClick={() => navigate("/ukraine-europe")}
          />
          <Item
            title={t("SelectContent.cardTitle2")}
            titleMain={t("SelectContent.cardTitle2Main")}
            img={ChinaImage}
            variant="orange"
            onClick={() => navigate("/china-europe")}
          />
        </div>
      </div>

      <Footer selectedLanguage={"eu"} languageTexts={t("ChinaToEurope")} showNav={false} />
    </div>
  );
}
